<template>
  <div class="contenedor">
    <router-view></router-view>
  </div>
</template>

<script>
import DetallePago from "./pages/DetallePago.vue";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    DetallePago
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss">
@import "sass/estilos.scss";
@import "sass/icons.scss";
</style>

<style>
/* Fuentes */

@font-face {
  font-family: TerpelSans-light;
  font-weight: 300;
  src: url("./assets/fonts/TerpelSans/TerpelSans-Light.otf") format("opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Light.eot")
    format("embedded-opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Light.woff2") format("woff2");
}
@font-face {
  font-family: TerpelSans;
  font-weight: normal;
  src: url("./assets/fonts/TerpelSans/TerpelSans-Regular.otf")
    format("opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Regular.eot")
    format("embedded-opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Regular.woff2") format("woff2");
}
@font-face {
  font-family: TerpelSans-medium;
  font-weight: 500;
  src: url("./assets/fonts/TerpelSans/TerpelSans-Medium.otf") format("opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Medium.eot")
    format("embedded-opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Medium.woff2") format("woff2");
}
@font-face {
  font-family: TerpelSans-bold;
  font-weight: bold;
  src: url("./assets/fonts/TerpelSans/TerpelSans-Bold.otf") format("opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Bold.eot")
    format("embedded-opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Bold.woff2") format("woff2");
}
@font-face {
  font-family: TerpelSans-black;
  font-weight: 900;
  src: url("./assets/fonts/TerpelSans/TerpelSans-Black.otf") format("opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Black.eot")
    format("embedded-opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-Black.woff2") format("woff2");
}
@font-face {
  font-family: TerpelSans-bolder;
  font-weight: bolder;
  src: url("./assets/fonts/TerpelSans/TerpelSans-ExtraBold.otf")
    format("opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-ExtraBold.eot")
    format("embedded-opentype");
  src: url("./assets/fonts/TerpelSans/TerpelSans-ExtraBold.woff2")
    format("woff2");
}
</style>

<style>
body {
  margin: 0;
}
.inicio {
  background-color: #fff;
  min-height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 99;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  flex-flow: column;
  align-items: center;
}

.contenedor {
  max-width: 906px;
  margin: 0 auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue